// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { IBreadcrumbItemModel, ListItemFactory  } from "@app/shared";
import { AbstractDepartmentModel } from "@app/catalog-common";
import { DepartmentDto } from "@app/catalog";


export class DepartmentModel extends AbstractDepartmentModel implements IBreadcrumbItemModel
{
    public thumbnailUrl: WritableSignal<string>;

    constructor()
    {
        super();
        this.thumbnailUrl = signal<string>(null);
    }

    public static fromDto(dto: DepartmentDto, isChecked: boolean = false)
    {
        let department = new DepartmentModel();
        
        //assign id, or if thats null, create a guid
        department.id = dto.id ?? crypto.randomUUID();
        department.name.set(dto.name);
        department.code.set(dto.code);
        department.thumbnailUrl.set(dto.thumbnailUrl);
        department.isActive.set(dto.isActive);
        department.isChecked.set(isChecked);
        
        return department;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<DepartmentModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<DepartmentModel>(this.name, this.id, this, selected);    

}
